import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

interface ContactButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
}

const ContactButton: React.FC<ContactButtonProps> = ({ 
  text = "Kontakt aufnehmen", 
  className = "",
  onClick
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to contact page
    navigate('/contact');
    
    // Call additional onClick handler if provided
    if (onClick) onClick();
  };

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleClick}
      className={`inline-flex items-center px-8 py-3 bg-accent-600 text-white font-medium rounded-full hover:bg-accent-700 transition-colors ${className}`}
    >
      <span className="relative z-10">{text}</span>
    </motion.button>
  );
};

export default ContactButton;